<template>
    <reveal-view>
        <h2 slot="header" class="title">Sūtīt ziņu</h2>
        <div class="content">
            <message-form :recipient="recipient" @sent="$modal.closeReveal()"></message-form>
        </div>
    </reveal-view>
</template>

<script>
    import RevealView from '../common/RevealView'
    import MessageForm from './MessageForm'

    export default  {
        props: {
            recipient: Object
        },
        data() {
            return {}
        },
        methods: {

        },
        components: {
            RevealView, MessageForm
        }
    }
</script>

<style lang="scss" scoped>
    //TODO combine with register reveal
    @import "../../../sass/settings";
    @import "../../../sass/mixins";

    .note {
        font-size: px-em(11px);

        label {
            font-size: inherit;
        }
    }

    .links {
        font-size: px-em(14px);
        text-align: center;
    }

    .content {
        max-width: px-em(360px);
        margin: 0 auto;
    }

    .social-buttons {
        flex-wrap: nowrap;

        > *:not(:last-child) {
            margin-right: 1rem;
        }
    }

    .or.fancy {
        margin-bottom: 1rem;
        color: $color-light-gray;

        > span:first-child,
        > span:last-child {
            border-top-color: $color-light-gray;
        }
    }
</style>


// WEBPACK FOOTER //
// resources/assets/js/components/inbox/MessageReveal.vue